export default "__VITE_ASSET__CpmqaXAr__"